import * as THREE from 'three';

/**
 * WebGL renderer and root Three.js scene.
 */
export class RendererSystem {
  /**
   * @param {{
   *   canvas: HTMLCanvasElement;
   *   config: import('../config.js').CONFIG['renderer'];
   * }} options
   */
  constructor({ canvas, config }) {
    this.threeRenderer = new THREE.WebGLRenderer({
      canvas,
      antialias: config.antialias,
      alpha: config.alpha,
    });
    this.threeRenderer.setPixelRatio(
      Math.min(window.devicePixelRatio, config.pixelRatioMax),
    );
    this.threeRenderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
    this.threeRenderer.outputColorSpace = THREE.SRGBColorSpace;
    this.threeRenderer.toneMapping = THREE.ACESFilmicToneMapping;
    this.threeRenderer.toneMappingExposure = config.toneMappingExposure;

    this.scene = new THREE.Scene();
    /** @type {import('./postprocessing/PostProcessingPipeline.js').PostProcessingPipeline | null} */
    this._pipeline = null;
  }

  /** @param {import('./postprocessing/PostProcessingPipeline.js').PostProcessingPipeline} pipeline */
  setPostProcessingPipeline(pipeline) {
    this._pipeline = pipeline;
  }

  setSize(width, height) {
    this.threeRenderer.setSize(width, height, false);
    const pr = this.threeRenderer.getPixelRatio();
    this._pipeline?.setSize(width, height, pr);
  }

  setPixelRatio(ratio) {
    this.threeRenderer.setPixelRatio(ratio);
  }

  /** @param {THREE.Camera} camera */
  render(camera) {
    if (this._pipeline) {
      this._pipeline.render();
    } else {
      this.threeRenderer.render(this.scene, camera);
    }
  }

  dispose() {
    this._pipeline?.dispose();
    this.threeRenderer.dispose();
  }
}
